import { useMemo } from 'react';

import ScenarioDetailModel from './ScenarioDetail.model';

export default function useSummaryData(data: any[]) {
  const tableData = useMemo(() => {
    if (data && Array.isArray(data)) {
      const summaryData = new ScenarioDetailModel().getSummaryData(data);
      return {
        rows: [{ ...summaryData, id: 'summaryData' }],
      };
    }
    return { rows: [] };
  }, [data]);

  return { tableData };
}
